import './products_overview.scss';
import Filter_Indicators from './filters/filter_indicators';
import Toggle from './filters/toggle';
import Price_Slider from './filters/price_slider';

window.addEventListener('load', ()=>{
    
    const indicators = new Filter_Indicators('.products_overview .filter_indicators.v1')
    indicators.register_buttons('.filter_field_custom-category button');
    indicators.register_buttons('.filter_field_product_cat button');
    indicators.register_buttons('.filter_field_special-requirement button');
    
    // const indicators_v2 = new Filter_Indicators('.products_overview .filter_indicators.v2');
    // indicators_v2.register_buttons('.filter_field_custom-category button');

    new Toggle({
        items: '.filter_field_product_cat .group',
        trigger: '.group-title',
        content: '.group-children',
    });

    // update posts count
    const ff_ajax = document.querySelector('.products_overview .ff_ajax').ff_ajax;
    const results_count = document.querySelector('.products_overview .results_count');

    // ff_ajax.on_query_response = (data)=>{
    //     console.log('on_query_response', data)
    // }

    ff_ajax.after_render = ()=>{
        if( typeof ff.wishlist !== 'undefined' ) {
            ff.wishlist.buttons_init(ff_ajax.loop)
        }
        if( typeof ff.compare !== 'undefined' ) {
            ff.compare.buttons_init(ff_ajax.loop)
        }
    }

    // on filter - update count
    ff_ajax.filters.on_query_response = (data)=>{
        // console.log('flters: on_query_response', data)
        results_count.textContent = data.total_posts_count;
    }

    // on search - update count
    ff_ajax.search.on_query_response = (data)=>{
        // console.log('search: on_query_response', data)
        results_count.textContent = data.total_posts_count;
    }
    
    new Price_Slider('.price_slider', {
        min: 1,
        max: 100,
        ff_ajax,
        on_query: (data)=>{
            // update count
            results_count.textContent = data.total_posts_count;
        }
    });


    let mobile_filter = document.querySelectorAll('.add_more_filter'); 
    mobile_filter.forEach(items => {
        items.onclick = function() {
            document.querySelector('.products_overview_filters').classList.toggle('active');
        }
    }); 
})